interface RegexPatternObj {
  regexPattern: RegExp
}

export const decimalNumberRegex: RegexPatternObj = {
  regexPattern: /^\d+[.,]\d+$|^\d+$/
}

export const inputNumberTypeRegex: RegexPatternObj = {
  regexPattern: /^[0-9,.]*$/
}

export const inputDatesTypeRegex: RegexPatternObj = {
  regexPattern: /^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}( )?(-)( )?([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/
}

export const inputDateTypeRegex: RegexPatternObj = {
  regexPattern: /^(\w{2,}\.){2,}\w{4,}$/
}

export const inputDateTypeFullYearRegex: RegexPatternObj = {
  regexPattern: /^(\w{2,}\.){2,}\w{4}$/
}
